import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useState } from 'react';

type Category = 'prompt-gen' | 'workflow' | 'account';

const categories: { id: Category; label: string }[] = [
  { id: 'account', label: 'Premium Account' },
  { id: 'prompt-gen', label: 'Prompt Gen' },
  { id: 'workflow', label: 'AI Workflow' },
];

const products = [
  {
    id: 'google-ai-pro',
    name: 'Google AI Pro 1 Tahun Plan',
    description: 'Percepat alur kerja dengan akses yang lebih tinggi',
    price: 'IDR 149.000',
    originalPrice: 'IDR 3.099.000',
    image: '/google-ai-pro.png',
    category: 'account' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo,%20saya%20ingin%20membeli%20Google%20AI%20Pro%201%20Tahun%20Plan.',
  },
  {
    id: 'google-ai-ultra',
    name: 'Google AI Ultra Privat | 25000 KREDIT',
    description: 'Gemini AI Pro | Google AI Pro Privat | VEO 3.1. Akses langsung ke teknologi canggih Google!',
    price: 'IDR 769.000',
    originalPrice: 'IDR 3.849.000',
    image: '/googleaiultra-baru.png',
    category: 'account' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo,%20saya%20ingin%20membeli%20Google%20AI%20Ultra%20Privat.',
  },
  {
    id: 'higgsfield-ai',
    name: 'HIGGSFIELD AI 1200C',
    description: 'Teknologi pergerakan video AI paling halus untuk kreator profesional',
    price: 'IDR 1.248.000',
    originalPrice: 'IDR 1.499.000',
    image: '/higgsfield-baru.png',
    category: 'account' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo,%20saya%20ingin%20membeli%20paket%20HIGGSFIELD%20AI%201200C.',
  },


  {
    id: 'ai-influencer-builder',
    name: 'Skill Generator: AI Influencer Character Builder',
    description: 'AI-influencer-builder adalah skill generator yang sudah kami rancang untuk memudahkan anda dalam pembuatan base karakter khususnya ai influencer yang hyper realistic dan no ai look.',
    price: 'IDR 149.000',
    originalPrice: 'IDR 349.000',
    image: '/ai-influencer-builder.png',
    category: 'prompt-gen' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20Skill%20Generator:%20AI%20Influencer%20Character%20Builder.',
  },
  {
    id: 'ai-influencer-video-builder',
    name: 'Skill Generator: AI Influencer Video Builder',
    description: 'AI-influencer-video-builder adalah skill generator yang sudah kami rancang untuk memudahkan anda dalam pembuatan video ai influencer with lypsnc yang tetap natural dan tidak terlihat dibuat menggunakan ai.',
    price: 'IDR 189.000',
    originalPrice: 'IDR 449.000',
    image: '/ai-influencer-video-builder.png',
    category: 'prompt-gen' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20Skill%20Generator:%20AI%20Influencer%20Video%20Builder.',
  },
  {
    id: 'ai-influencer-character-matching',
    name: 'Skill Generator: AI Influencer Character Matching',
    description: 'Character-matching-builder adalah skill generator yang sudah kami rancang untuk memudahkan anda dalam meniru pose/adegan, mood, color grading, lighting, tempat dan lainnya dari reference image yang ingin kalian tiru.',
    price: 'IDR 129.000',
    originalPrice: 'IDR 249.000',
    image: '/ai-influencer-character-matching.png',
    category: 'prompt-gen' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20Skill%20Generator:%20AI%20Influencer%20Character%20Matching.',
  },
  {
    id: 'ai-affiliate-unboxing-asmr',
    name: 'Skill Generator: AI Affiliate Unboxing ASMR Video',
    description: 'affiliate-unboxing asmr-builder adalah skill generator yang sudah kami rancang untuk memudahkan anda dalam pembuatan konten affiliate unboxing asmr, jadi mempercepat dalam pembuatan konten AI affiliate anda.',
    price: 'IDR 99.000',
    originalPrice: 'IDR 149.000',
    image: '/ai-affiliate-unboxing-asmr.png',
    category: 'prompt-gen' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20Skill%20Generator:%20AI%20Affiliate%20Unboxing%20ASMR%20Video.',
  },
  {
    id: 'ai-influencer-motion-builder',
    name: 'Skill Generator: AI Influencer Motion Builder',
    description: 'AI-Influencer-Motion-Builder adalah skill generator yang sudah kami rancang untuk memudahkan Anda dalam pembuatan video AI influencer khususnya untuk meniru adegan suatu reference video, mau itu dance, adegan sebuah video dan lainnya yang pastinya tetap natural, konsistensi karakter terjaga dan tidak terlihat dibuat menggunakan AI.',
    price: 'IDR 149.000',
    originalPrice: 'IDR 249.000',
    image: '/ai-influencer-motion-builder.png',
    category: 'prompt-gen' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20Skill%20Generator:%20AI%20Influencer%20Motion%20Builder.',
  },
  {
    id: 'outfit-swap-builder',
    name: 'Skill Generator: Outfit Swap Builder',
    description: 'Outfit-Swap-Builder adalah skill generator yang sudah kami rancang untuk memudahkan Anda dalam mengganti wardrobe atau outfit karakter AI tanpa mengubah detail karakter.',
    price: 'IDR 149.000',
    originalPrice: 'IDR 249.000',
    image: '/outfit-swap-builder.png',
    category: 'prompt-gen' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20Skill%20Generator:%20Outfit%20Swap%20Builder.',
  },
  {
    id: 'short-ads-workflow',
    name: 'Short Ads/Film Workflow',
    description: 'Pelajari rahasia membuat iklan pendek dan film cinematic yang konsisten mulai dari karakter, storyboard hingga moodboard yang pas untuk project kalian menggunakan AI Visuals.',
    price: 'IDR 129.000',
    originalPrice: 'IDR 269.000',
    image: '/products/thumbnail-short-ads.png',
    category: 'workflow' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20memesan%20Short%20Ads%2FFilm%20Workflow.',
  },

  {
    id: 'konsisten-karakter-workflow',
    name: 'Workflow Konsisten Karakter Untuk Scane Apapun',
    description: 'Workflow ini membahas proses lengkap untuk menjaga konsistensi karakter, mulai dari prompt structure, base character, multiple angle, hingga penerapan karakter ke berbagai scene agar tetap konsisten. Sistem ini bisa kamu aplikasikan ke berbagai project AI seperti brand ads, campaign visual, film-style content, dan kebutuhan kreatif lainnya.',
    price: 'IDR 129.000',
    originalPrice: 'IDR 269.000',
    image: '/products/thumbnail-konsisten-karakter.png',
    category: 'workflow' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20Workflow%20Konsisten%20Karakter.',
  },
  {
    id: 'foto-product-workflow',
    name: 'Workflow Rahasia Foto Product ala Studio Mahal',
    description: 'Workflow ini membahas proses lengkap bagaimana rahasia foto product biar terlihat lebih profesional, konsistensi product, mulai dari prompt structure, base product, multiple angle, hingga penerapan product ke berbagai scene agar tetap konsisten. Sistem ini bisa kamu aplikasikan ke berbagai project AI seperti brand ads, campaign visual, film-style content, dan kebutuhan kreatif lainnya.',
    price: 'IDR 129.000',
    originalPrice: 'IDR 269.000',
    image: '/products/thumbnail-foto-product.png',
    category: 'workflow' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20Workflow%20Rahasia%20Foto%20Product.',
  },
  {
    id: 'base-karakter-workflow',
    name: 'Workflow Rahasia Base Karakter Ultra-Realistic',
    description: 'Dalam panduan ini, Anda akan mempelajari proses lengkap menciptakan karakter dasar (base character) beserta rahasia struktur prompt-nya. Sistem ini sangat fleksibel dan dapat diaplikasikan untuk berbagai proyek AI, terutama untuk kampanye periklanan dan konten bergaya film.',
    price: 'IDR 129.000',
    originalPrice: 'IDR 269.000',
    image: '/products/thumbnail-base-karakter.png',
    category: 'workflow' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20Workflow%20Base%20Karakter.',
  },
  {
    id: 'virtual-try-on-workflow',
    name: 'Rahasia Virtual Try-On Workflow',
    description: 'Dalam workflow ini, Anda akan mempelajari teknik rahasia mengganti pakaian (change outfit) pada sebuah foto menggunakan AI. Panduan ini sangat direkomendasikan bagi pemilik merek fashion yang ingin menekan biaya produksi visual secara signifikan, tanpa perlu menyewa model atau mengadakan sesi foto berulang kali.',
    price: 'IDR 129.000',
    originalPrice: 'IDR 269.000',
    image: '/products/thumbnail-virtual-try-on.png',
    category: 'workflow' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20Virtual%20Try-On%20Workflow.',
  },
  {
    id: 'nano-workflow',
    name: 'Nano Banana Workflow',
    description: 'Bongkar rahasia workflow asli dari Ikhsanztech Studio. Dari satu gambar jadi film sinematik utuh.',
    price: 'IDR 49.000',
    originalPrice: 'IDR 750.000',
    image: '/products/gambar-nano.png',
    category: 'workflow' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20memesan%20Nano%20Banana%20Workflow.',
  },
  {
    id: 'speedramp-workflow',
    name: 'Speedramp Effect Workflow',
    description: 'Mindset AI Video Director dengan tutorial Nano Banana Pro. Efek cinematic profesional untuk video Anda.',
    price: 'IDR 49.000',
    originalPrice: 'IDR 899.000',
    image: '/products/gambar-speedramp.png',
    category: 'workflow' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20Speedramp%20Effect%20Workflow.%20Mohon%20info%20pembayarannya.',
  },

  {
    id: 'chatgpt-plus',
    name: 'ChatGPT Plus 5.5 (1 Bulan)',
    description: 'ChatGPT Plus dengan fitur lengkap: Codex, Sora, mode agen, dan memori percakapan.',
    price: 'IDR 250.000',
    originalPrice: 'IDR 1.047.000',
    image: '/chatgpt-plus.png',
    category: 'account' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo%20Ikhsanztech-studio,%20saya%20ingin%20membeli%20ChatGPT%20Plus%205.5%20(1%20Bulan).%20Mohon%20info%20pembayarannya.',
  },
  {
    id: 'adobe-cc-pro',
    name: 'Adobe Creative Cloud Pro - 4 Bulan',
    description: '',
    price: 'IDR 349.000',
    originalPrice: 'IDR 1.384.320',
    image: '/adobe-ai-pro.png',
    category: 'account' as Category,
    whatsappLink: 'https://wa.me/6287877066270?text=Halo,%20saya%20ingin%20membeli%20Adobe%20Creative%20Cloud%20Pro%20-%204%20Bulan.',
  },
];

function ProductCard({ product, index }: { product: typeof products[0]; index: number }) {
  return (
    <Link to={`/produk/${product.id}`} className="block">
      <motion.div
        id={product.id}
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.3, delay: index * 0.03 }}
        whileHover={{ scale: 1.01 }}
        className="bg-gradient-to-br from-white/8 via-zinc-900/50 to-zinc-900/30 backdrop-blur-xl border border-white/10 rounded-2xl px-4 py-4 flex flex-col md:flex-row gap-4 md:gap-6 group cursor-pointer items-center hover:border-white/25 hover:shadow-[0_8px_32px_rgba(59,130,246,0.15)] transition-all duration-300"
      >
        {/* Product Image - Left */}
        <div className="w-24 md:w-28 flex-shrink-0 aspect-square rounded-xl overflow-hidden bg-white/5">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-contain opacity-90 group-hover:opacity-100 transition-opacity duration-300"
          />
        </div>

        {/* Product Info - Center */}
        <div className="flex-1 text-center md:text-left">
          <h3 className="font-inter font-bold text-sm md:text-base text-white group-hover:text-white/80 transition-colors">
            {product.name}
          </h3>
          <p className="text-white/50 text-xs mt-1 leading-relaxed line-clamp-2">{product.description}</p>
          <div className="flex items-baseline gap-2 mt-2 justify-center md:justify-start">
            <span className="text-sm md:text-base font-bold text-white">
              {product.price}
            </span>
            <span className="text-[10px] text-white/30 line-through">{product.originalPrice}</span>
          </div>
          {/* Mini Checklist */}
          <div className="flex flex-wrap gap-2 mt-2 justify-center md:justify-start">
            <span className="text-white/50 text-[10px] flex items-center gap-1">
              <svg className="w-3 h-3 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              Akses Instant
            </span>
            <span className="text-white/50 text-[10px] flex items-center gap-1">
              <svg className="w-3 h-3 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              Garansi
            </span>
          </div>
        </div>

        {/* CTA - Right */}
        <div className="w-full md:w-auto flex-shrink-0">
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="px-5 py-2.5 rounded-full bg-black text-white font-bold text-xs border border-white/10 hover:border-white/20 hover:bg-zinc-900 transition-all text-center whitespace-nowrap"
          >
            Beli Sekarang
          </motion.div>
        </div>
      </motion.div>
    </Link>
  );
}


export function ProductsSection() {
  const [activeCategory, setActiveCategory] = useState<Category>(() => {
    const saved = localStorage.getItem('lastProductCategory');
    if (saved === 'account' || saved === 'prompt-gen' || saved === 'workflow') {
      return saved as Category;
    }
    return 'account';
  });

  const filteredProducts = products.filter(product => product.category === activeCategory);

  return (
    <section id="produk-digital" className="relative py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8"
        >
          <h2 className="font-sora text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 uppercase tracking-widest">
            PRODUK DIGITAL
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto text-sm sm:text-base font-light">
            Produk digital premium untuk meningkatkan produktivitas dan kreativitas Anda
          </p>
        </motion.div>

        {/* Category Filter */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex flex-wrap justify-center gap-3 mb-10"
        >
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => {
                setActiveCategory(cat.id);
                localStorage.setItem('lastProductCategory', cat.id);
              }}
              className={`px-5 py-2 rounded-xl text-sm font-medium backdrop-blur-md border transition-all duration-300 ${activeCategory === cat.id
                ? 'bg-white/20 border-white/40 text-white'
                : 'bg-white/5 border-white/10 text-white/70 hover:bg-white/10 hover:border-white/20'
                }`}
            >
              {cat.label}
            </button>
          ))}
        </motion.div>

        {/* Products List */}
        <div className="flex flex-col gap-4">
          <AnimatePresence mode="wait">
            {filteredProducts.map((product, index) => (
              <ProductCard key={product.id} product={product} index={index} />
            ))}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}
